import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39cc78fc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=39cc78fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc78fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39cc78fc')) {
      api.createRecord('39cc78fc', component.options)
    } else {
      api.reload('39cc78fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39cc78fc&scoped=true&", function () {
      api.rerender('39cc78fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/image-upload/index.vue"
export default component.exports